import { customElement } from "lit/decorators.js";
import { css, html, TemplateResult } from "lit";
import { LitElement } from "lit";
import { getCustomPropertyValueInPx } from "../../util/getCustomPropertyValueInPx";
import { Carousel } from "./carousel";

@customElement("ehm-carousel-item")
export class CarouselItem extends LitElement {
  static styles = css`
    :host {
      display: flex;
      flex: 1;
      box-sizing: content-box !important;
      scroll-snap-align: start;
    }
  `;

  #siteMaxWidth: number;
  #sitePadding: number;
  #isFirstChild = this.previousElementSibling === null;
  #isLastChild = this.nextElementSibling === null;
  #gap = 0;
  #container: Carousel | null = null;

  constructor() {
    super();
    this.#siteMaxWidth = getCustomPropertyValueInPx("--site-max-width--lg");
    this.#sitePadding = getCustomPropertyValueInPx("--site-padding");
    this.#gap = getCustomPropertyValueInPx("--gutter-lg");
  }

  firstUpdated() {
    this.#container = this.closest("ehm-carousel");
    this.#container?.addEventListener("carousel-updated", () => this.#calculatePadding());
    this.#calculatePadding();
    window.addEventListener("resize", () => this.#calculatePadding());
  }


  #calculatePadding() {
    if (this.#container?.disabled) {
      this.removeAttribute("style");
      return;
    }

    this.#gap = getCustomPropertyValueInPx("--gutter-lg");
    this.#sitePadding = getCustomPropertyValueInPx("--site-padding");

    let leftPadding = this.#gap;
    let rightPadding = 0;

    // Distance from screen edge to wrapper content edge
    let edgePadding: number;
    if (window.innerWidth <= this.#siteMaxWidth) {
      edgePadding = this.#sitePadding;
    } else {
      edgePadding = (window.innerWidth - this.#siteMaxWidth) / 2 + this.#sitePadding;
    }

    if (this.#isFirstChild) leftPadding = edgePadding;
    if (this.#isLastChild) rightPadding = edgePadding;

    this.style.paddingLeft = `${leftPadding}px`;
    this.style.paddingRight = `${rightPadding}px`;
  }

  render(): TemplateResult {
    return html`
      <slot></slot> `;
  }
}